module.exports = __webpack_public_path__ + "static/media/shoeIso.e65877dd.png";